import { FailedAlertContainer, SideDrawerLink, FailedIcon } from "./MoaDashboard.styles";
import React, { FC } from "react";

interface FailedAlertProps {
  count: number;
  openDrawer: () => void;
  id: string;
}

const FailedAlert: FC<FailedAlertProps> = (
    {
      count,
      openDrawer,
      id
    }
) => {
  return (
      <FailedAlertContainer>
        <FailedIcon
            fontSize="medium"
        />
        <SideDrawerLink
            label={`${count} failed`}
            to={''}
            onClick={openDrawer}
            dataTestId={`failedLink-${id}`}
        />
      </FailedAlertContainer>
  )
}

export default FailedAlert;